export const CUSTOMER_FEEDBACK_REQUEST = "CUSTOMER_FEEDBACK_REQUEST";
export const CUSTOMER_FEEDBACK_SUCCESS = "CUSTOMER_FEEDBACK_SUCCESS";
export const CUSTOMER_FEEDBACK_FAILURE = "CUSTOMER_FEEDBACK_FAILURE";